import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import Section from "../components/Section";
import Pitch from "../components/Pitch";
import Questions from "./Questions.md";
// Images
import imgExpert from "../images/g-suite-expert.png";

class Expert extends Component {
  constructor() {
    super();
    this.state = { markdown: "" };
  }
  UNSAFE_componentWillMount() {
    // Get the contents from the Markdown file and put them in the React state, so we can reference it in render() below.
    fetch(Questions)
      .then(res => res.text())
      .then(text => this.setState({ markdown: text }));
  }
  render() {
    const { markdown } = this.state;

    const title = "Prospection, votre expert G Suite";

    const text1 = `Les spécialistes en technologie de l'information de Prospection maîtrisent toutes les subtilités de G Suite qui vous permettront d'utiliser pleinement ses capacités. Grâce aux configurations optimales des fonctionnalités de G Suite, vous pourrez travailler et communiquer efficacement, quelle que soit la taille de votre entreprise.
      Nous prenons en charge la migration de vos courriels, données, fichiers vers G Suite, rapidement, efficacement en toute sécurité.`;
    const text2 = `Pour vous, nous configurons vos services de courriel Gmail, y associons vos noms de domaines et créons les alias pour chaque compte. Vous pourrez partager vos agendas entre collaborateurs, communiquer facilement et organiser des conférences vidéos jusqu'à 25 participants. Vous pourrez travailler facilement sur différents types de documents, les partager et garder le contrôle sur leurs versions.
    `;
    const osbl = `Vous gérez un organisme sans but lucratif (OSBL ou fondation) ? Prospection effectue les démarches pour que vous obteniez des licences gratuites de G Suite.`;

    return (
      <Section type="expert">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h2>{title}</h2>
              <Pitch>
                <ReactMarkdown source={markdown} />
              </Pitch>
              <ReactMarkdown source={text1} />
              <ReactMarkdown source={text2} />
              <p className="highlight">{osbl}</p>
            </div>
            <div className="col-lg-6">
              <img
                className="img-fluid imgExpert"
                src={imgExpert}
                alt="Expertise G Suite"
              />
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

export default Expert;
